import { observer } from 'mobx-react';
import styled from 'styled-components';

// Components
import { Layout } from 'top-component-library';

// Constants
import breakpoints from 'constants/breakpoints';
import { footer } from 'constants/style';

// Hooks
import { useStores } from 'hooks/use-stores';

// Tracking
import { userNavigationTrackingEvents } from 'integrations/segment/tracking-events';
import React from 'react';

const LegacyFooter = (): React.ReactElement => {
  const { hostStore } = useStores();
  const { settings } = hostStore;
  const clickPrivacyPolicy = (): void => {
    userNavigationTrackingEvents.trackClickPrivacyPolicy();
  };

  const clickTermsAndConditions = (): void => {
    userNavigationTrackingEvents.trackClickTermsAndConditions();
  };

  return (
    <LegacyFooterFooter data-is-visible={settings?.show_bbot_footer ? 1 : 0}>
      <a
        href="https://help.doordash.com/legal/document?type=cx-privacy-policy&region=US&locale=en-US/"
        onClick={clickPrivacyPolicy}
      >
        Privacy Policy
      </a>
      <a
        href="https://help.doordash.com/legal/document?type=bbot-terms-and-conditions&region=US&locale=en-US"
        onClick={clickTermsAndConditions}
        target="_blank"
        rel="noreferrer"
      >
        Terms and Conditions
      </a>
      {settings?.hostname === 'bbot.menu' && <a href="mailto:bb-support@doordash.com">Bbot Support</a>}
      <span>Powered by DoorDash</span>
    </LegacyFooterFooter>
  );
};

export default observer(LegacyFooter);

const LegacyFooterFooter = styled(Layout.Footer)`
  background-color: transparent;
  display: flex;
  height: ${footer.mobile.height}px;
  padding-left: 1rem;
  padding-right: 1rem;
  position: relative;
  width: 100%;
  z-index: 2;
  color: #ffffff;

  @media (min-width: ${breakpoints.md}px) {
    box-shadow: initial;
    height: ${footer.desktop.height}px;
    justify-content: initial;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  a,
  span {
    font-size: 0.625rem;
    letter-spacing: 0.25px;

    @media (min-width: ${breakpoints.md}px) {
      font-size: 0.9375rem;
      letter-spacing: 0.75px;
    }
  }

  a {
    color: #ffffff;
    margin-right: 0.5rem;

    @media (min-width: ${breakpoints.xxs}px) {
      margin-right: 1.25rem;
    }

    @media (min-width: ${breakpoints.md}px) {
      margin-right: 2rem;
    }

    &:focus,
    &:hover {
      opacity: 0.8;
    }
  }

  // "Powered by DoorDash"
  span {
    color: #ffffff;
    margin-left: auto;
    opacity: 0.645; // Lowest accessibly opacity
  }

  &[data-is-visible='0'] {
    span {
      visibility: hidden;
    }
  }
`;
